// IM-UX-176 (IM-SAAS-003): o acesso à organização ativa foi encerrado (vínculo desativado ou removido) e a pessoa
// pertence a outras organizações. Nada é escolhido automaticamente: a pessoa decide onde continuar.
import { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import { BrandLogo } from '../components/BrandLogo';
import { EmptyState } from '../components/States';
import { friendlyError } from '../lib/errors';

export function ChooseOrganization() {
  const { me, logout, switchOrganization } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const usable = (me?.organizations ?? []).filter((o) => !o.suspended);
  return (
    <section className="pa-gate" aria-labelledby="page-title">
      <div className="pa-gate-card card">
        <BrandLogo variant="public" />
        <EmptyState title="Escolha a organização" glyph="lock" tone="amber">
          Seu acesso à organização anterior não está mais disponível. Escolha outra organização para continuar ou fale com o administrador dela.
        </EmptyState>
        {error && <div className="form-error" role="alert">{error}</div>}
        <div className="pa-switch-list"><span className="eyebrow">Suas organizações</span>
          {usable.map((o) => <button key={o.id} type="button" className="secondary" onClick={() => switchOrganization(o.id).catch((e) => setError(friendlyError(e, 'Não foi possível trocar agora.')))}>{o.name}</button>)}
        </div>
        <div className="pa-gate-foot"><button type="button" className="link-btn" onClick={logout}>Sair</button></div>
      </div>
    </section>
  );
}
